var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentCenter.type === 'TRANSIT')?_c('div',[_c('TransitDashboard')],1):(_vm.currentCenter.type === 'REHABILITATION')?_c('div',[_c('RehabDashboard')],1):(
    // && currentUser.roles === null
    _vm.currentCenter.type === 'NRS_HEADQUARTERS'
  )?_c('div',[_c('NrsDashboard')],1):_c('div',[_c('AdminDashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }